var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25630",
    "data-name": "Group 25630",
    transform: "translate(-559 -216)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14183",
    "data-name": "Rectangle 14183",
    width: 26,
    height: 26,
    rx: 5,
    transform: "translate(559 216)",
    fill: "#533ffb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons8-play",
    transform: "translate(559.422 217.754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30586",
    "data-name": "Path 30586",
    d: "M8.5,6.511v9.47a.922.922,0,0,0,1.369.806l8.546-4.735a.922.922,0,0,0,0-1.613L9.869,5.7A.922.922,0,0,0,8.5,6.511Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30587",
    "data-name": "Path 30587",
    d: "M8.5,6.511v9.47a.922.922,0,0,0,1.369.806l8.546-4.735a.922.922,0,0,0,0-1.613L9.869,5.7A.922.922,0,0,0,8.5,6.511Z",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterPlay);
export default __webpack_public_path__ + "static/media/filter-play.fd13a0b5ad69604998c3ff00de2f718c.svg";
export { ForwardRef as ReactComponent };